import React from 'react';
import DashboardPage from './DashboardPage';
import RestrictedHomePage from './RestrictedHomePage';
import { useShell } from '../components/Layout';

// «Главная»: the dashboard, or the to-do list while the account may not use the service yet.
const DashboardGate = () => {
  const { profile } = useShell();
  return profile?.restriction ? <RestrictedHomePage /> : <DashboardPage />;
};

export default DashboardGate;
